export * from "./Figcaption.js";
